module.exports = __webpack_public_path__ + "img/FK.39a5ea14.svg";